import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "vision.token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

/**
 * Location scope
 * --------------
 * AuthContext keeps this in sync with the currently-signed-in user:
 *   - Administrator: whatever they've picked in the Location Switcher, or null
 *     for "All Locations".
 *   - Any other role: forced to the user's own location_id (server-side
 *     enforcement also present as belt-and-braces).
 *
 * The interceptor auto-appends `?location_id=<scope>` to every GET, so every
 * list, dashboard count, and filter endpoint respects the scope without each
 * page having to remember. A request may explicitly opt out by setting
 * `_skipScope: true` on the axios config (used by the LocationSwitcher to
 * fetch the full active-Locations list).
 *
 * Per-page filters can still narrow further (e.g. picking a specific location
 * inside the Employees master screen): the interceptor only injects when the
 * request doesn't already carry a `location_id` param.
 */
let _locationScope = null;

export const setLocationScope = (id) => {
  _locationScope = id || null;
};

export const getLocationScope = () => _locationScope;

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;

  const method = (cfg.method || "get").toLowerCase();
  const alreadySet =
    cfg.params && Object.prototype.hasOwnProperty.call(cfg.params, "location_id");
  if (method === "get" && _locationScope && !cfg._skipScope && !alreadySet) {
    cfg.params = { ...(cfg.params || {}), location_id: _locationScope };
  }
  return cfg;
});

/**
 * FastAPI 422 returns { detail: [ { msg, ... } ] } — turn any error into a
 * plain string so React never crashes rendering an object.
 */
export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}
